module.exports = __webpack_public_path__ + "static/media/md-battery-charging.71537640.svg";